import * as React from "react";
import { Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { formatDate } from "utilities/date";
import ProgressScale from "components/ProgressScale";
import DummyTable from "components/DummyViews/DummyTable";
import { useSelector } from "react-redux";
import TenantPaymentsTable from "components/Tables/TenantPaymentsTable";
import { useGetTenantOccupancyActivePeriodsData } from "services/hooks/rentals";
import PlainCard from "components/PlainCard";


export default function TenantPayments(props) {
	const [details, setDetails] = React.useState("");
	const occupancy = useSelector((state) => state.occupancy)
    const { activePeriods, isLoadingActivePeriods } = useGetTenantOccupancyActivePeriodsData();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const openPopper = Boolean(anchorEl);
	const popperId = openPopper ? "simple-popover" : undefined;



	const handleClickPopOver = (event) => {
		setAnchorEl(event.currentTarget);
	};


	return (
		<Box m="20px">
			<Grid container spacing={2}>
				<Grid item xs={12}>
					{isLoadingActivePeriods && <ProgressScale />}
					<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom:"20px"}}>
						<Typography variant="h3" className="pageHeader">Tenant Payments for {occupancy.related_tenant.first_name+' '+occupancy.related_tenant.last_name+' in Unit '+occupancy.related_rental_unit.unit_name+'-'+occupancy.related_rental_unit.related_rental.rental_name}</Typography>
					</div>
					
					<div>
						<Grid container>
							<Grid item xs={12} md={3}><PlainCard name="Days Left" value={activePeriods.days_left} /></Grid>
							<Grid item xs={12} md={3}><PlainCard name="Unit Rent" value={activePeriods.unit_rent} /></Grid>
							<Grid item xs={12} md={3}><PlainCard name="Current Outstanding Balance" value={activePeriods.money} /></Grid>
							<Grid item xs={12} md={3}><PlainCard name="Total Complete Months" value={activePeriods.completed_months} /></Grid>
						</Grid>
					</div>
					<Grid container spacing={2}>
						<Grid item xs={12} sx={{ marginTop: 3 }}>
							{isLoadingActivePeriods ? (
								<DummyTable />
							) : (
								<TenantPaymentsTable
									rows={activePeriods.schedules}
									handleClickPopOver={handleClickPopOver}
									id={popperId}
									formatDate={formatDate}
									setDetails={setDetails}
								/>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
}
